<div class="" [class.hidden]="showAffix()">
  <div [ngClass]="selectedComboRooms()?.length && selectedRooms?.length ? '!h-[400px]': 'h-auto'"
    class="bg-white w-full p-4 flex flex-col" *ngIf="selectedRooms?.length || selectedComboRooms()?.length">

    <div [ngClass]="{'is-open': selectedComboRooms()[0]?.rooms?.length}"
      class="flex items-center justify-between w-full cursor-pointer border-bottom pb-2 mb-2" #accordion
      (click)="toggleSelectedRoomsAccordion()">
      <p class="text-sm font-bold text-black">اتاق های انتخابی({{ allRoomsCount +
        (selectedComboRooms()[0]?.rooms?.length ?? 0) }})</p>
      <i class="ico-Up text-2xl text-black-300 transition-all"></i>
    </div>

    <!-- rooms slider -->
    <div class="flex flex-grow overflow-x-scroll !overflow-y-hidden x-scroll gap-3 h-0 transition-all"
      [class.selected-combo-rooms-box]="selectedComboRooms()?.length" #accordionBody>

      <div class="w-full" *ngIf="selectedComboRooms()?.length">
        <div class="indicator-dots absolute right-0 top-1 flex flex-col items-center gap-1">
          <span class="h-2 w-2 border border-solid border-black-100 rounded-full"></span>
          <span class="line"></span>
          <span class="h-2 w-2 border border-black-100 border-solid bg-black-100 rounded-full"></span>
        </div>

        <div class="flex flex-col gap-1 items-start mr-5">
          <div class="flex flex-col gap-2 items-start w-full"
            *ngFor="let eachRoom of selectedComboRooms()[0]?.rooms; let i = index">
            <div class="flex justify-between items-center w-full flex-grow">
              <h6 class="text-sm text-black">{{ eachRoom.roomName }} </h6>
              <i class="text-2xl text-muted ico-Close hover:text-gray-500 cursor-pointer" *ngIf="i === 0"
                (click)="removeComboRoomFromSelection()"></i>
            </div>
            <div class="flex items-center gap-4 justify-start text-xs">
              <p class="text-muted">ورود : {{ eachRoom.priceInfo.checkInDate }}</p>
              <p class="text-black-300 px-2 py-1 rounded bg-black-50">{{ eachRoom.priceInfo?.nights }} شب </p>
              <p class="text-muted">خروج : {{ eachRoom.priceInfo.checkOutDate }}</p>
            </div>

            <div class="flex w-full items-center gap-1 justify-end md:justify-center">
              <span class="text-sm text-muted">{{ eachRoom.priceInfo?.nights }} شب</span>
              <span class="text-black-500 text-2xl font-bold">{{
                eachRoom.priceInfo?.ihoPrice | toToman | number : '2.'
                }}</span>
              <span class="text-sm text-muted">تومان</span>
            </div>
          </div>
        </div>
      </div>


      <div class="selected-room-box" *ngFor="let eachRoom of selectedRooms">
        <div class="selected-room-box_header">
          <h6 class="text-sm text-black">{{ eachRoom.name }}</h6>
          <i class="text-2xl text-muted ico-Close hover:text-gray-500 cursor-pointer"
            (click)="removeSpecificRoom(eachRoom.id)"></i>
        </div>

        <span class="text-xs text-black-300 -mt-1">{{ eachRoom.count }} اتاق</span>

        <div class="selected-room-box_price-section">
          <span class="text-black text-xl font-bold">{{ eachRoom.roomPrice?.price?.ihoPrice | toToman | number: '2.'
            }}</span>
          <span class="text-sm text-muted">تومان</span>
        </div>
      </div>
      <!-- <div class="w-[2px] h-full bg-gray-300 rounded-lg"></div> -->
    </div>

    <div class="w-full flex justify-between items-center flex-grow">
      <div class="flex-1 flex flex-col">
        <span class="text-base text-gray-500 font-bold ">مبلغ قابل پرداخت</span>
        <div class="flex items-center">
          <span class="text-black text-xl font-bold">{{ (totalPrice + selectedComboPrice) | toToman | number: '2.'
            }}</span>
          <span class="text-sm text-muted mr-1">تومان</span>
        </div>
      </div>
      <div class="flex-1 flex justify-center items-center flex-grow">
        <a mat-flat-button color="primary" class="w-full !h-11 !min-w-[40%] block lg:hidden" id="make-reservation-btn"
          (click)="goToFollowReservation()">اقدام به
          رزرو</a>
      </div>
    </div>
  </div>
</div>